import {
  IDriveViewFolder,
  IDriveViewTagFilters,
} from '@commenda/types/src/drive-view/types';
import { SWRFetcher } from '@commenda/utils';
import useSWR from 'swr';

export type TDriveViewScope =
  | { type: 'corporation'; corporationId: number }
  | { type: 'keyPerson'; directorId: number };

export function useGetDriveViewV2(
  scope: TDriveViewScope,
  tagFilters?: IDriveViewTagFilters
) {
  const query = new URLSearchParams();
  if (scope.type === 'corporation') {
    query.append('corporationId', scope.corporationId.toString());
    query.append('viewType', 'v2');
  } else {
    query.append('directorId', scope.directorId.toString());
  }

  if (tagFilters?.fiscalYearTag != null)
    query.append('fiscalYearTag', tagFilters.fiscalYearTag.toString());
  if (tagFilters?.periodTagType)
    query.append('periodTagType', tagFilters.periodTagType);
  if (tagFilters?.periodTagValue != null)
    query.append('periodTagValue', tagFilters.periodTagValue.toString());
  if (tagFilters?.country) query.append('country', tagFilters.country);
  if (tagFilters?.jurisdiction)
    query.append('jurisdiction', tagFilters.jurisdiction);
  if (tagFilters?.taxType) query.append('taxType', tagFilters.taxType);
  if (tagFilters?.sourceType)
    query.append('sourceType', tagFilters.sourceType);
  if (tagFilters?.documentCategory)
    query.append('documentCategory', tagFilters.documentCategory);

  const url = `drive-view/view?${query.toString()}`;

  const shouldFetch =
    (scope.type === 'corporation' && scope.corporationId > 0) ||
    (scope.type === 'keyPerson' && scope.directorId > 0);

  const { data, error, isLoading, mutate } = useSWR<{ folder: IDriveViewFolder }>(
    shouldFetch ? url : null,
    SWRFetcher({ method: 'GET' })
  );

  return { data, error, isLoading, mutate };
}
